var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/EnumAspect.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html } from "lit";
import { AbstractAspect } from "./AbstractAspect.js";
var EnumAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    if (!this.fieldName)
      return null;
    if (this.value === null || this.value === void 0)
      return null;
    return {
      [this.fieldName]: {
        $eq: this.value
      }
    };
  }
};
EnumAspect._class = "EnumAspect";
__decorateClass([
  Field((type) => String)
], EnumAspect.prototype, "enumName", 2);
__decorateClass([
  Field((type) => String)
], EnumAspect.prototype, "value", 2);
EnumAspect = __decorateClass([
  Entity()
], EnumAspect);
var EnumAspectSchema = {
  aspectConstructor: EnumAspect,
  renderEditor: ({ aspectValue, translation }) => {
    const enumName = aspectValue.enumName;
    const enumClass = baseqlMetaData.enums[enumName]?.enum;
    if (enumClass === void 0)
      throw new Error("enum not found " + enumName);
    const keys = Object.keys(enumClass).filter((k) => !k.startsWith("_"));
    return html` <x-dropdown-selection
      ${css({ minWidth: "150px" })}
      .selectables=${keys}
      clearable
      .renderString=${(value) => typeof value === "string" ? translation.translate("enums", value) : translation.translate("filter", "empty")}
      .value=${aspectValue.value}
      @value-picked=${(e) => aspectValue.value = e.detail.value}
    ></x-dropdown-selection>`;
  },
  renderPreview: ({ aspectValue, translation }) => typeof aspectValue.value !== "string" ? null : html` <x-text> ${translation.translate("enums", aspectValue.value)} </x-text> `
};
export {
  EnumAspect,
  EnumAspectSchema
};
